import React from 'react';
import { Row, Column, Text } from '../../src/components/common';
import QRCode from 'qrcode.react';
import LabelQrWrapper from './labelQrWrapper';
import { object } from 'prop-types';
import { get, isEmpty, split, join, compact } from 'lodash';

const PositionsQr = ({ match, location }) => {
    const validateEmpty = (item) => isEmpty(item) ? '' : item;
    const queryParams = new URLSearchParams(location.search);
    const sectorPicking = queryParams.get('sectorPicking');
    const place = validateEmpty(queryParams.get('place'));
    const aisle = validateEmpty(queryParams.get('aisle'));
    const position = validateEmpty(queryParams.get('position'));
    const numqr = get(match, 'params.id');

    const formatTextPositions = () => {
        const textCleaned = compact(split(`${place} ${aisle} ${position}`, ' '));
        return join(textCleaned, '-');
    };

    return (
        <LabelQrWrapper>
            {({ isPrinting }) => {
                return (<div style={{ margin: '0 auto', width: `${!isPrinting ? '10cm' : '6.5cm'}`, height: '100%' }}>
                    <Column style={{ border: '1px solid #000000', alignContent: isPrinting ? 'flex-end' : '' }} borderRadius={4}>
                        <Row justify={isPrinting ? 'flex-end' : 'center'} style={{ margin: 5 }}>
                            <QRCode value={numqr} size={!isPrinting ? 150 : 100} />
                        </Row>
                        <Column align='center'>
                            <Text text={numqr} size={!isPrinting ? 12 : 7} />
                            {!isEmpty(sectorPicking) && <Text text={sectorPicking} size={!isPrinting ? 15 : 8.5} strong />}
                            <Text text={formatTextPositions()} strong size={!isPrinting ? 15 : 8.5} />
                        </Column>
                    </Column>
                </div>);
            }}
        </LabelQrWrapper>
    );
};

PositionsQr.propTypes = {
    match: object,
    location: object
};

export default PositionsQr;
